import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonEN from './locales/en/common.json';
import navigationEN from './locales/en/navigation.json';
import authEN from './locales/en/auth.json';
import mealsEN from './locales/en/meals.json';
import healthEN from './locales/en/health.json';
import settingsEN from './locales/en/settings.json';
import communityEN from './locales/en/community.json';
import mypageEN from './locales/en/mypage.json';
import questionnaireEN from './locales/en/questionnaire.json';
import informationEN from './locales/en/information.json';
import hospitalEN from './locales/en/hospital.json';
import chatbotEN from './locales/en/chatbot.json';
import diaryEN from './locales/en/diary.json';
import eventEN from './locales/en/event.json';
import noticeEN from './locales/en/notice.json';
import contactEN from './locales/en/contact.json';

const resources = {
  en: {
    common: commonEN,
    navigation: navigationEN,
    auth: authEN,
    meals: mealsEN,
    health: healthEN,
    settings: settingsEN,
    community: communityEN,
    mypage: mypageEN,
    questionnaire: questionnaireEN,
    information: informationEN,
    hospital: hospitalEN,
    chatbot: chatbotEN,
    diary: diaryEN,
    event: eventEN,
    notice: noticeEN,
    contact: contactEN,
  },
};

i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    resources,
    lng: 'en', // Force English language
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'navigation', 'auth', 'meals', 'health', 'settings', 'community', 'mypage', 'questionnaire', 'information', 'hospital', 'chatbot', 'diary', 'event', 'notice', 'contact'],

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    detection: {
      // order and from where user language should be detected
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
